// extracted by mini-css-extract-plugin
export default {"blogPage":"BlogPage_blogPage__C4fUK"};